var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationsLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Application") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a/icons/micro/70/Application",
    transform: "translate(0.000000, 1.000000)",
    stroke: "#D8D8DE",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "17.886075 26.5957304 0.145644002 26.5957304 0.145644002 0 26.3149583 0 26.3149583 19.4162577"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(13.230301, 56.608456) rotate(-90.000000) translate(-13.230301, -56.608456) ",
    points: "3.02183518 69.8387576 0.0788237085 69.8387576 0.0788237085 43.3781554 26.3817785 43.3781554 26.3817785 55.0651464"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#EEF0F3",
    cx: 40.3290635,
    cy: 43.0816628,
    rx: 18.8521104,
    ry: 18.9483837
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(56.769699, 13.297865) rotate(-270.000000) translate(-56.769699, -13.297865) ",
    points: "59.1934887 26.5281663 43.6182215 26.5281663 43.6182215 0.0675640633 69.9211763 0.0675640633 69.9211763 7.71481719"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.1671088,
    y1: 69.4245808,
    x2: 53.7242395,
    y2: 56.6084565,
    id: "Path-4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsLarge);
export default __webpack_public_path__ + "static/media/applications-large.fcf26943.svg";
export { ForwardRef as ReactComponent };